module.exports = __webpack_public_path__ + "static/media/ic_arrow_right_w.67e514db.svg";